export const REGISTER_USER = 'register_user';
export const REGISTER_USER_SUCCESS = 'register_user_success';
export const REGISTER_USER_FAILURE = 'register_user_failure';

export const LOGIN_USER = 'login_user';
export const LOGIN_USER_SUCCESS = 'login_user_success';
export const LOGIN_USER_FAILURE = 'login_user_failure';

export const LOGOUT_USER = 'logout_user';

export const CREATE_FOOD_REQUEST = 'create_food_request';
export const CREATE_FOOD_REQUEST_SUCCESS = 'create_food_request_success';
export const CREATE_FOOD_REQUEST_FAILURE = 'create_food_request_failure';

export const FETCH_USER_FOOD_REQUEST = 'fetch_user_food_request';
export const FETCH_USER_FOOD_REQUEST_SUCCESS =
  'fetch_user_food_request_success';
export const FETCH_USER_FOOD_REQUEST_FAILURE =
  'fetch_user_food_request_failure';
